import { Chip, IconButton, TableCell, TableHead, TableRow } from '@material-ui/core'
import { Delete, Edit } from '@material-ui/icons'
import React from 'react'
import { StaffProfileResponseType } from 'types/api/temple'

interface StaffProfileTableProps {
    profiles: StaffProfileResponseType[]
    editHandler?: (id: string | number) => void
    deleteHandler?: (id: string | number) => void
    deletingIds?: (string | number)[]
}

const roleLabel = (value: string) => value.charAt(0).toUpperCase() + value.slice(1)

const StaffProfileTable: React.FC<StaffProfileTableProps> = ({
    profiles,
    editHandler,
    deleteHandler,
    deletingIds = [],
}) => (
    <React.Fragment>
        <TableHead>
            <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Languages</TableCell>
                <TableCell>Status</TableCell>
                {(editHandler || deleteHandler) && <TableCell align='right'>Actions</TableCell>}
            </TableRow>
        </TableHead>
        {profiles.map(profile => (
            <TableRow key={profile.id}>
                <TableCell>{profile.fullName}</TableCell>
                <TableCell>{profile.email || '-'}</TableCell>
                <TableCell>{profile.phone || '-'}</TableCell>
                <TableCell>{roleLabel(profile.role)}</TableCell>
                <TableCell>
                    {roleLabel(profile.roleType)}
                    {profile.priestType ? ` / ${roleLabel(profile.priestType)}` : ''}
                </TableCell>
                <TableCell>{profile.languages.length > 0 ? profile.languages.join(', ') : '-'}</TableCell>
                <TableCell>
                    <Chip
                        size='small'
                        color={profile.isActive ? 'primary' : 'default'}
                        label={profile.isActive ? 'Active' : 'Inactive'}
                    />
                </TableCell>
                {(editHandler || deleteHandler) && (
                    <TableCell align='right'>
                        {editHandler && (
                            <IconButton onClick={() => editHandler(profile.id)}>
                                <Edit fontSize='small' />
                            </IconButton>
                        )}
                        {deleteHandler && (
                            <IconButton
                                disabled={deletingIds.includes(profile.id)}
                                onClick={() => deleteHandler(profile.id)}
                            >
                                <Delete fontSize='small' />
                            </IconButton>
                        )}
                    </TableCell>
                )}
            </TableRow>
        ))}
        {profiles.length === 0 && (
            <TableRow>
                <TableCell colSpan={8}>No staff profiles found</TableCell>
            </TableRow>
        )}
    </React.Fragment>
)

export default StaffProfileTable
